class MarkerMarkupSync {
  // NOTE: In the future this component should probably store information on where the
  //       Marker should be anchored to the Markup, i.e top bottom center, top left, etc...
}

export default MarkerMarkupSync;
